import { conversionTrackSubmitted } from '~/public/lib/ConversionEventTracking.js';
import { redirectFromThankYou } from '~/components/forms/questions/ThankYouConfirmation.jsx';

export function handleFormSubmissionResponse(response) {
    conversionTrackSubmitted(response?.context || {});

    return redirectFromThankYou(response?.redirectUri);
}
